const CODEGEN_MESSAGES_PLAYFUL = [
  "Raiding the pantry (columns)",
  "Sniffing dtypes",
  "Picking pans for axes",
  "Taste-testing encodings",
  "Sifting outliers",
  "Measuring cups for units",
  "Whisking summary stats",
  "Folding in facets",
  "Sorting the spice rack",
  "Choosing the color palette",
  "Chopping labels and titles",
  "Lining the tray (layout)",
  "Pinch of uncertainty",
  "Setting the error bars",
  "Arranging the garnish (legend)",
  "Quick kitchen hygiene check",
  "Sketching the recipe (GO)",
  "Plan taste test (validation)",
  "Preheating for sandbox"
];
export {
  CODEGEN_MESSAGES_PLAYFUL
};
